import parseISO from 'date-fns/parseISO';

const makeSafeDate = (date: string | Date) => {
    if (date instanceof Date) {
      return date;
    }

    return parseISO(date);
}

export default makeSafeDate;